import { ensurePdfExtension } from "@persolog/utils";
import { ProfileAdministrationAPI, ProfileContractorAPI } from "../api";
import { ParticipantActivityType } from "../types/PersologOnlineTypes.ts";
import { usePdfViewerStore, type PdfFetchParams } from "../stores/pdfViewer.ts";
import router from "../router/index.ts";

export function openPdf(url: string, fileName: string, participantId: number, logActivity = true) {
    const a = document.createElement("a");
    a.href = url;
    a.rel = "noopener noreferrer";
    a.download = ensurePdfExtension(fileName);

    document.body.appendChild(a);

    a.click();

    globalThis.URL.revokeObjectURL(url);
    a.remove();
    if(logActivity) {
        ProfileAdministrationAPI.logParticipantActivity(
            participantId,
            ParticipantActivityType.PROFILE_DOWNLOADED_BY_TRAINER,
        );
    }
}

export async function getPdfUrl(trainer: string, product: string, participantId: number, language: string) {
    const { blob, filename } = await ProfileContractorAPI.authenticatedPdfDownload(
        trainer,
        product,
        participantId,
        language,
    );
    const pdfFile = new File([blob], filename, { type: "application/pdf" });
    const objectUrl = globalThis.URL.createObjectURL(pdfFile);
    return { objectUrl, filename, blob: pdfFile as Blob };
}

export async function getChartPdfUrl(product: string, projectId: number, language: string) {
    const blob = await ProfileContractorAPI.downloadPdf(product, projectId, language);
    return globalThis.URL.createObjectURL(blob);
}

export async function openPdfInNewTab(blob: Blob, filename: string, fetchParams?: PdfFetchParams) {
    const normalizedFilename = ensurePdfExtension(filename);
    const store = usePdfViewerStore();
    const returnRoute = router.currentRoute.value.fullPath;
    store.open(blob, normalizedFilename, returnRoute, fetchParams);
    await router.push({ name: "PdfViewer" });
}

export async function fetchGeneratedProfileLanguages(product: string, participantId: number) {
    return await ProfileContractorAPI.fetchLanguages(product, participantId);
}
